import { MODAL_PRICING } from '@components/App/Modal/constants'
import { UpgradePlanActions } from '@store/reducers/upgradePlan'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { selectIsLoading } from '@/store'

export const useUpgradePlan = () => {
  const dispatch = useDispatch()

  const loading = useSelector(selectIsLoading('upgrade_plan'))

  const handleClickAllPlan = () => {
    sendGtmEvent(GtmTriggerName.UPGRADE_ALL_FEATURES)

    dispatch(openModal(MODAL_PRICING))
  }

  const handleUpgradePlan = (planId: string) => {
    dispatch(UpgradePlanActions.upgrade({ planId }))
  }

  return {
    loading,
    handleClickAllPlan,
    handleUpgradePlan,
  }
}
